module.exports = __webpack_public_path__ + "img/5322033.b6970c7d.png";